import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState ={
    isLoading : true,
    users: [],
    totalUsers: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    userDetail:{}
    
};


const allUserSlice = createSlice({
    name: "allUsers",
    initialState,
    reducers:{
        getAllUserPending: (state) => {
            state.isLoading = true;
        },
        getAllUserSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.users = payload;
            state.userDetail = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getAllUserFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
    },
});

const { reducer, actions } = allUserSlice;

export const { getAllUserPending, getAllUserSuccess, getAllUserFail } = actions;

export default reducer;
